(function($) {
    $(() => {
        $('.watermarked-block__quotes').slick({
            dots: true,
            dotsClass: 'slick-dots watermarked-block__quotes--dots',
            prevArrow: `
                <button class="btn btn-primary btn-rounded watermarked-block__quotes--previous">
                    <svg width="13" height="22" viewBox="0 0 13 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.4142 10.9999L12.7071 20.2928L11.2929 21.707L0.585773 10.9999L11.2929 0.292816L12.7071 1.70703L3.4142 10.9999Z" fill="currentColor"/>
                    </svg>
                </button>
            `,
            nextArrow: `
                <button class="btn btn-primary btn-rounded watermarked-block__quotes--next">
                      <svg width="13" height="22" viewBox="0 0 13 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M1 1L11 11L1 21" stroke="currentColor" stroke-width="2"/>
                      </svg>
                </button>
            `
        });

        $('.projects-block__gallery').slick({
            asNavFor: '.projects-block__table__gallery',
            arrows: false,
            slidesToShow: 1,
            centerMode: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        centerMode: false
                    }
                }
            ]
        });
        $('.projects-block__table__gallery').slick({
            asNavFor: '.projects-block__gallery',
            arrows: false,
            fade: true,
            swipe: false
        });
        $('.projects-block__gallery').on('afterChange', (_, { currentSlide, slideCount }) => {
            $('.projects-block__counter--number').text(`${currentSlide + 1} / ${slideCount}`);
        });
        $('.projects-block__counter--previous').click(() => {
            $('.projects-block__gallery').slick('slickPrev');
        });
        $('.projects-block__counter--next').click(() => {
            $('.projects-block__gallery').slick('slickNext');
        });

        jQuery( ".section-single-houses-slider" ).each(function() {
            $('.js-houses-slider').slick({
                arrows: true,
                dots: false,
                slidesToShow: 1,
                prevArrow:  jQuery(this).find('.js-arrow-left'),
                nextArrow:  jQuery(this).find('.js-arrow-right'),
                fade: true,
                cssEase: 'linear'
            });

            $('.js-houses-slider').on('afterChange', (_, { currentSlide, slideCount }) => {
                jQuery(this).find('.section-single-houses-slider__slider__counter--number').text(`${currentSlide + 1} / ${slideCount}`);
            });
        });

        jQuery( ".section-houses-images" ).each(function() {
            $('.js-houses-images-slider').slick({
                arrows: true,
                dots: false,
                slidesToShow: 4,
                slidesToScroll: 4,
                prevArrow:  jQuery(this).find('.js-arrow-left'),
                nextArrow:  jQuery(this).find('.js-arrow-right'),
                cssEase: 'linear'
            });

            $('.js-houses-images-slider').on('afterChange', (_, { currentSlide, slideCount }) => {
                jQuery(this).find('.section-houses-images-slider__slider__counter--number').text(`${currentSlide + 1} / ${slideCount}`);
            });
        });
    });
})(jQuery);
